import React from 'react';

const TicketContext = React.createContext(null);

export default TicketContext;
